import { render, staticRenderFns } from "./HKLFormItem.vue?vue&type=template&id=25ac61c5&scoped=true&"
import script from "./HKLFormItem.vue?vue&type=script&lang=js&"
export * from "./HKLFormItem.vue?vue&type=script&lang=js&"
import style0 from "./HKLFormItem.vue?vue&type=style&index=0&id=25ac61c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ac61c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ac61c5')) {
      api.createRecord('25ac61c5', component.options)
    } else {
      api.reload('25ac61c5', component.options)
    }
    module.hot.accept("./HKLFormItem.vue?vue&type=template&id=25ac61c5&scoped=true&", function () {
      api.rerender('25ac61c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Form/HKLFormItem.vue"
export default component.exports